<div class="mw-100">
    <app-navbar></app-navbar>
    <div class="row">
        <div class="container">
            <app-device-table></app-device-table>
        </div>
    </div>
</div>